/**
 * Scheuch Process Designer
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { SeuApiComputationResponseDto } from '../model/computationResponseDto';
// @ts-ignore
import { SeuApiCopySolutionToInputDto } from '../model/copySolutionToInputDto';
// @ts-ignore
import { SeuApiCopySolutionToInputResponseDto } from '../model/copySolutionToInputResponseDto';
// @ts-ignore
import { SeuApiOfferComputation } from '../model/offerComputation';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { SeuApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface ComputeOfferRequestParams {
  /** The ID of the offer */
  offerId: string;
  seuApiOfferComputation: SeuApiOfferComputation;
}

export interface CopySolutionToInputRequestParams {
  seuApiCopySolutionToInputDto: SeuApiCopySolutionToInputDto;
}

export interface ExportOfferRequestParams {
  /** The ID of the offer */
  offerId: string;
  /** Export type: EXCEL or EB_IMPORT */
  exportType: 'EXCEL' | 'EB_IMPORT';
  /** The same configurations as they were used for the computations */
  seuApiOfferComputation: Array<SeuApiOfferComputation>;
  /** Language for the export. */
  language?: 'DE' | 'EN';
}

@Injectable({
  providedIn: 'root',
})
export class OfferComputationApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: SeuApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * Compute offer streams
   * Calculates stream data for the given offer and computation inputs
   * @endpoint post /offerComputations/offers/{offerId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public computeOffer(
    requestParameters: ComputeOfferRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiComputationResponseDto>;
  public computeOffer(
    requestParameters: ComputeOfferRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiComputationResponseDto>>;
  public computeOffer(
    requestParameters: ComputeOfferRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiComputationResponseDto>>;
  public computeOffer(
    requestParameters: ComputeOfferRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling computeOffer.'
      );
    }
    const seuApiOfferComputation = requestParameters?.seuApiOfferComputation;
    if (
      seuApiOfferComputation === null ||
      seuApiOfferComputation === undefined
    ) {
      throw new Error(
        'Required parameter seuApiOfferComputation was null or undefined when calling computeOffer.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offerComputations/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiComputationResponseDto>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiOfferComputation,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves all data needed to copy a solution from a calculation to the input of a specific component.
   * @endpoint post /offerComputations/offers/copySolutionsToInput
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public copySolutionToInput(
    requestParameters: CopySolutionToInputRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiCopySolutionToInputResponseDto>;
  public copySolutionToInput(
    requestParameters: CopySolutionToInputRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiCopySolutionToInputResponseDto>>;
  public copySolutionToInput(
    requestParameters: CopySolutionToInputRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiCopySolutionToInputResponseDto>>;
  public copySolutionToInput(
    requestParameters: CopySolutionToInputRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seuApiCopySolutionToInputDto =
      requestParameters?.seuApiCopySolutionToInputDto;
    if (
      seuApiCopySolutionToInputDto === null ||
      seuApiCopySolutionToInputDto === undefined
    ) {
      throw new Error(
        'Required parameter seuApiCopySolutionToInputDto was null or undefined when calling copySolutionToInput.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offerComputations/offers/copySolutionsToInput`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiCopySolutionToInputResponseDto>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiCopySolutionToInputDto,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Export offer computation
   * Exports the offer computation data to the specified format (Excel, EB_IMPORT)
   * @endpoint post /offerComputations/offers/{offerId}/export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportOffer(
    requestParameters: ExportOfferRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/octet-stream' | 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public exportOffer(
    requestParameters: ExportOfferRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/octet-stream' | 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public exportOffer(
    requestParameters: ExportOfferRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/octet-stream' | 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public exportOffer(
    requestParameters: ExportOfferRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/octet-stream' | 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling exportOffer.'
      );
    }
    const exportType = requestParameters?.exportType;
    if (exportType === null || exportType === undefined) {
      throw new Error(
        'Required parameter exportType was null or undefined when calling exportOffer.'
      );
    }
    const seuApiOfferComputation = requestParameters?.seuApiOfferComputation;
    if (
      seuApiOfferComputation === null ||
      seuApiOfferComputation === undefined
    ) {
      throw new Error(
        'Required parameter seuApiOfferComputation was null or undefined when calling exportOffer.'
      );
    }
    const language = requestParameters?.language;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>exportType,
      'exportType'
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>language,
      'language'
    );

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/octet-stream',
        'application/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offerComputations/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/export`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seuApiOfferComputation,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress,
    });
  }
}
